import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const AITPRJ01 = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/ed78d3c5-e43_big.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Delhi Agra Tour (AITP / RJ-01)</h1>

            <p className="hero-subtitle">
              3 Nights / 4 Days • Golden Triangle Experience
            </p>

            <div className="hero-price">
              Starting From <span>₹11,800*</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + ENQUIRY */}
        <Row className="mb-4">

          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/a012ae50-3b5_big.jpg" alt="" />
                <img src="/Images/tour/3c1abd28-989_big.jpg" alt="" />
                <img src="/Images/tour/03356a1a-0b5_big.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹11,800*</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Delhi Agra Tour Package</h1>
              <p>3 Nights / 4 Days • Delhi – Mathura – Agra</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Akshardham Mandir</Col>
                <Col md={6}>✔ Taj Mahal Agra</Col>
                <Col md={6}>✔ Lotus Temple Delhi</Col>
                <Col md={6}>✔ Agra Fort</Col>
                <Col md={6}>✔ India Gate</Col>
                <Col md={6}>✔ Raj Ghat</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Explore India's iconic Golden Triangle route covering Delhi,
                Mathura, Vrindavan and Agra. Experience Mughal heritage,
                spiritual temples and world-famous monuments including
                the Taj Mahal.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Delhi
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival pickup & hotel check-in. Visit Red Fort and
                    evening shopping at Chandni Chowk or Karol Bagh.
                    Overnight stay in Delhi.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Delhi Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Jama Masjid, India Gate, Qutub Minar,
                    Humayun's Tomb, Raj Ghat, Parliament House and
                    Connaught Place. Overnight stay in Delhi.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Delhi to Agra via Mathura & Vrindavan
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Agra visiting Dwarkadhish Temple,
                    Banke Bihari Mandir, Nidhivan Temple and ISKCON.
                    Hotel check-in and overnight stay in Agra.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Agra to Delhi Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Taj Mahal and Agra Fort. Later drive back
                    to Delhi for airport or railway station drop.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusions */}
            <div className="content-box">
              <Row>
                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul>
                    <li>Hotel Accommodation</li>
                    <li>Breakfast & Dinner</li>
                    <li>Private Transport</li>
                    <li>Sightseeing as per itinerary</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul>
                    <li>Monument Entry Fees</li>
                    <li>Personal Expenses</li>
                    <li>Travel Insurance</li>
                    <li>Lunch & Tips</li>
                  </ul>
                </Col>
              </Row>
            </div>

            {/* Hotel Details */}
            <div className="content-box">
              <h3>Hotel Details</h3>
              <p>
                Deluxe category hotels in Delhi & Agra with modern
                amenities, daily breakfast and comfortable stay.
              </p>
            </div>

            {/* Rate Summary */}
            <div className="content-box">
              <h3>Rate & Summary</h3>
              <p>
                Starting price ₹11,800 per person based on double sharing.
                Rates may vary depending on season and availability.
              </p>
            </div>

            {/* Terms */}
            <div className="content-box">
              <h3>Terms & Conditions</h3>
              <ul>
                <li>Booking subject to availability.</li>
                <li>50% advance required for confirmation.</li>
                <li>Cancellation charges applicable.</li>
              </ul>
            </div>

            {/* Travel Tips */}
            <div className="content-box">
              <h3>Travel Tips</h3>
              <ul>
                <li>Carry valid ID proof.</li>
                <li>Wear comfortable walking shoes.</li>
                <li>Best season: October – March.</li>
              </ul>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default AITPRJ01;